import { apiClient } from "./client";

export interface Notifica {
  id: string;
  tipo: string;
  messaggio: string;
  entity_type: string | null;
  entity_id: string | null;
  letta: boolean;
  created_at: string;
}

/** Proprie notifiche recenti + conteggio non lette (Fase 3.4). */
export async function listNotifiche(): Promise<{ notifiche: Notifica[]; non_lette: number }> {
  const { data } = await apiClient.get<{ notifiche: Notifica[]; non_lette: number }>("/notifiche");
  return data;
}

export async function segnaLetta(id: string): Promise<{ success: true }> {
  const { data } = await apiClient.patch<{ success: true }>(`/notifiche/${id}/letta`);
  return data;
}

export async function segnaTutteLette(): Promise<{ success: true }> {
  const { data } = await apiClient.patch<{ success: true }>("/notifiche/lette");
  return data;
}
